import { useAuth } from '@/auth/hyper-auth'

const overrideConfig = {
    baseURL: process.env.VUE_APP_CS_URL,
    namespace: process.env.VUE_APP_NAMESPACE,
    serviceGroup: process.env.VUE_APP_SERVICE,
    specificAuthKeyName: 'cs-auth'
}

const service = {

}

export {
    service,
    overrideConfig,
    useAuth
}
